import { useRecoilValue } from 'recoil'

import CardWithBorder from '../../../components/CardWithBorder'
import DoughnutChart from '../../../components/DoughnutChart_userVisitFrequency'
import useLocationDateTimeForm from '../../../hooks/useLocationDateTimeForm'
import { ServiceAtom } from '../../../recoil/atoms'
import useGetStoreVisitCountDistribution from '../hooks/useGetStoreVisitCountDistribution'

function UserVisitFrequency({ className }: { className?: string }) {
  const { form } = useLocationDateTimeForm()
  const service = useRecoilValue(ServiceAtom)

  const { storeVisitCountDistribution, storeVisitCountDistributionLoading } = useGetStoreVisitCountDistribution({
    serviceId: service.value,
    siteId: form.siteId,
    floorId: form.floorId,
    siteGroupId: form.siteGroupId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })

  const labels = ['1回来訪', '2回来訪', '3回来訪', '4回来訪', '5回来訪', '6回来訪', '7回来訪', '8回以上来訪']
  const labelData = labels.map((label, index) => ({
    id: `visit-${index + 1}`,
    label,
    value: storeVisitCountDistribution?.storeVisitCountDatas[index] ?? 0
  }))

  return (
    <CardWithBorder className={className} title='来訪回数分布' visible={storeVisitCountDistributionLoading}>
      <DoughnutChart labelData={labelData} />
    </CardWithBorder>
  )
}

UserVisitFrequency.defaultProps = {
  className: '',
}

export default UserVisitFrequency
